import { Vector3 } from "../../../../maths/Vector3";
export class WebDirectLight {
    constructor() {
        this._shadowFourCascadeSplits = new Vector3();
        this._direction = new Vector3();
    }
    setShadowFourCascadeSplits(value) {
        value && value.cloneTo(this._shadowFourCascadeSplits);
    }
    setDirection(value) {
        value && value.cloneTo(this._direction);
    }
}
